module.exports = __webpack_public_path__ + "static/img/财务级场景_产品图_image@2x.fca28ab0.png";